module.exports = __webpack_public_path__ + "static/img/PY.a77c8033.svg";